"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrdersModule = /** @class */ (function () {
    function OrdersModule() {
    }
    return OrdersModule;
}());
exports.OrdersModule = OrdersModule;
